
export const HOST_API = import.meta.env.VITE_HOST_API;
export const GOOGLE_MAP_API = import.meta.env.VITE_GOOGLE_MAP_API;
export const PATH_ERP = import.meta.env.VITE_PATH_ERP;
// export const FIREBASE_URL = import.meta.env.VITE_FIREBASE_DATABASE_URL;
export const FIREBASE_URL = import.meta.env.VITE_FIREBASE_DATABASE_URLTEST;

export const FIREBASE_CONFIG = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    // databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URLTEST,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
